import React from 'react';
import {type FormatOptionLabelMeta} from 'react-select';

import {type ProjectOption} from './hooks';
import * as S from './JobDrawerConfigImporter.styles';

interface ProjectOptionLabelProps {
  props: ProjectOption;
  context: FormatOptionLabelMeta<ProjectOption>;
}

export const ProjectOptionLabel = ({
  props,
  context,
}: ProjectOptionLabelProps) => {
  const {entityName, projectName} = props;

  // show single line when the dropdown is closed
  if (context.context === 'value') {
    return (
      <S.OptionLabel>
        <S.OptionaLabelText>
          {entityName}/{projectName}
        </S.OptionaLabelText>
      </S.OptionLabel>
    );
  }

  // show multiline when the dropdown is open
  return (
    <S.OptionLabel>
      <S.OptionaLabelText>{projectName}</S.OptionaLabelText>
      <S.OptionLabelSubtitleText>{entityName}</S.OptionLabelSubtitleText>
    </S.OptionLabel>
  );
};
